/* @flow */

export const FORMA_PAGAMENTO_TIPO_ONLINE = 6;
export const FORMA_PAGAMENTO_PAGSEGURO = 39;
export const FORMA_PAGAMENTO_PLOM_CASH = 40;
export const FORMA_PAGAMENTO_IUGU = 41;
